import { Component, computed, input, output } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { EngagementContactSelectOption } from './engagement-contact-select.model';

@Component({
  selector: 'app-engagement-contact-select',
  templateUrl: './engagement-contact-select.component.html',
  styleUrls: ['./engagement-contact-select.component.scss'],
  imports: [MatFormFieldModule, MatSelectModule],
})
export class EngagementContactSelectComponent {
  readonly options = input<EngagementContactSelectOption[]>([]);
  readonly value = input<number | null>(null);
  readonly selectionChange = output<number>();

  readonly selectedOption = computed(() => {
    const options = this.options();

    if (!options?.length) {
      return null;
    }

    const currentValue = this.value();

    if (!currentValue) {
      return options[0];
    }

    return options.find(option => option.contactId === currentValue) ?? options[0];
  });

  onSelectionChange(contactId: number): void {
    this.selectionChange.emit(contactId);
  }
}
